import {http} from '@/helpers/http-helper';

class UnsubscribeReason {
    constructor(
        uuid,
        name,
        active
    ) {
        this.uuid = uuid;
        this.name = name;
        this.active = active;
    }
}

export const getUnsubscribeReasons = () => {
    return new Promise( (resolve, reject) => {
        const url = 'unsubscribe/reasons';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let unsubscribeReasons = [];
                    response.data.forEach((unsubscribeReason) => {
                        unsubscribeReasons.push(new UnsubscribeReason(
                            unsubscribeReason.uuid,
                            unsubscribeReason.name,
                            unsubscribeReason.active
                        ));
                    });

                    resolve(unsubscribeReasons);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteUnsubscribeReason = (unsubscribeReasonId) => {
    return new Promise((resolve, reject) => {
        const url = 'unsubscribe/reasons/' + unsubscribeReasonId;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};